import { memo, useMemo, type FC, type JSX } from 'react'

type Props = {
  condition: boolean
  wrapperTrue: (children: JSX.Element) => JSX.Element
  wrapperFalse: (children: JSX.Element) => JSX.Element
  children: JSX.Element
  [key: string]: any // Allow passing additional props to the wrappers
}

const defaultWrapper = (children: JSX.Element) => children

export const ConditionalWrapper: FC<Props> = memo(({ condition, wrapperTrue, wrapperFalse, children }) => {
  const Wrapper = useMemo(() => (condition ? typeof wrapperTrue === 'function' ? wrapperTrue : defaultWrapper : typeof wrapperFalse === 'function' ? wrapperFalse : defaultWrapper), [condition, wrapperTrue, wrapperFalse])
  return Wrapper(children)
})
